var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarNotfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.78278 1.27205C8.01514 0.556905 9.02688 0.556903 9.25925 1.27205L10.6994 5.70447C10.8033 6.02429 11.1014 6.24083 11.4377 6.24083H16.0982C16.8501 6.24083 17.1628 7.20304 16.5544 7.64503L12.784 10.3844C12.5119 10.5821 12.3981 10.9324 12.502 11.2523L13.9422 15.6847C14.1746 16.3998 13.356 16.9945 12.7477 16.5525L8.97727 13.8131C8.70521 13.6155 8.33682 13.6155 8.06476 13.8131L4.29432 16.5525C3.68598 16.9945 2.86747 16.3998 3.09983 15.6847L4.54001 11.2523C4.64393 10.9324 4.53009 10.5821 4.25803 10.3844L0.487591 7.64503C-0.120746 7.20305 0.191897 6.24083 0.943843 6.24083H5.60437C5.94065 6.24083 6.23868 6.02429 6.3426 5.70447L7.78278 1.27205Z",
    fill: "#6EAEFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNotfilled);
export default __webpack_public_path__ + "static/media/Star-notfilled.8c1c47001ae9a58f50a4649cfd81fed6.svg";
export { ForwardRef as ReactComponent };